const doc = [({"zh_cn":({"adminConstantChargeType":({"perPerson":"每人", "perRoom":"每间客房"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;